module.exports = __webpack_public_path__ + "banner.7d3d85998cf69a41c22f.jpg";


//////////////////
// WEBPACK FOOTER
// D:/01.Developer/0.Web/Bravo8-Base/src/assets/img/banner.jpg
// module id = ../../../../../src/assets/img/banner.jpg
// module chunks = styles